import React from "react";
import "./FinnovateUpdateDialog.css";

const FinnovateUpdateDialog = ({ open, onClose }) => {
    if (!open) return null;
    console.log("FinnovateUpdateDialog rendered");
    return (
        <div className="login-page">
            <div
                className="fvx-modal-overlay is-open"
                role="dialog"
                aria-modal="true"
                aria-labelledby="fvxTitle"
                aria-describedby="fvxDesc"
            >
                <div className="fvx-modal" tabIndex="-1">
                    {/* Top bar */}
                    <div className="fvx-topbar">
                        <div className="fvx-label">Update</div>

                        <button
                            className="fvx-close"
                            type="button"
                            aria-label="Close"
                            onClick={onClose}
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M18 6L6 18M6 6l12 12"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Content */}
                    <h2 className="fvx-title" id="fvxTitle">
                        A new Finnovate experience awaits.
                    </h2>

                    <p className="fvx-desc" id="fvxDesc">
                        A redesigned experience across the platform.
                        <br />
                        Faster, simpler, and easier to use.
                    </p>

                    <p className="fvx-micro">
                        You’re currently on the previous version.
                    </p>

                    {/* Actions */}
                    <div className="fvx-actions">
                        <button
                            className="fvx-btn fvx-btn--secondary"
                            type="button"
                            onClick={onClose}
                        >
                            Stay on previous version
                        </button>

                        <button
                            className="fvx-btn fvx-btn--primary"
                            onClick={() => window.location.href = "https://wealth.finnovate.in/email-login"}
                        >
                            Continue to the new Finnovate
                        </button>
                    </div>

                    <p className="fvx-footnote">
                        Your account and data stay the same.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FinnovateUpdateDialog;
